export default __webpack_public_path__ + "static/media/SFAPlayIcon.04ab15ba.svg";